import { render, staticRenderFns } from "./xitongduijie.vue?vue&type=template&id=3cd86fef&scoped=true&"
import script from "./xitongduijie.vue?vue&type=script&lang=ts&"
export * from "./xitongduijie.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd86fef",
  null
  
)

export default component.exports